import type { Tomo } from '../types/content'

export const tomos: Tomo[] = [
  {
    number: 1,
    emoji: '📗',
    tag: 'Ensamblaje',
    title: 'Manual de Ensamblaje 5 Minutos',
    accent: '#2ea8e8',
    tagline:
      'El corazón del sistema. Proteína lista en minutos, sin recetas complicadas ni tiempo de más.',
    bullets: [
      'El Método 1-2-3 para tener proteína lista en minutos',
      '15 recetas proteicas listas en 5 minutos exactos',
      'Lista de compras smart + planner semanal imprimible',
      'Timing proteico: cuándo y cómo distribuir la proteína en el día',
    ],
  },
  {
    number: 2,
    emoji: '📘',
    tag: 'Sustitución',
    title: 'Sustitución Inteligente: Góndola vs Fit',
    accent: '#7fcbf0',
    tagline:
      'Todo lo que el marketing fit te cobra de más, resuelto con alimentos reales de supermercado.',
    bullets: [
      'Reemplazá el Whey con alimentos reales de góndola',
      'Tabla maestra de sustituciones proteicas accesibles',
      'Cómo leer etiquetas y no caer en la trampa fit',
      '15 recetas de sustitución con ingredientes de supermercado',
    ],
  },
  {
    number: 3,
    emoji: '📙',
    tag: 'Repostería',
    title: 'Repostería Proteica de Rescate',
    accent: '#f0c44a',
    tagline: 'Para el antojo nocturno que rompe cualquier plan.',
    bullets: [
      '15 postres proteicos sin azúcar añadida',
      'Brownie · Pancakes · Mousse · Cookies de avena',
      'Tabla de sustituciones dulces para cualquier receta',
      'Plan anti-atracón para el antojo nocturno',
    ],
  },
  {
    number: 4,
    emoji: '📕',
    tag: 'AirFryer',
    title: 'El Método AirFryer & Microondas',
    accent: '#e0a80d',
    tagline: 'Proteína crujiente sin ensuciar la cocina ni perder la tarde.',
    bullets: [
      'Proteína crujiente en menos de 15 minutos exactos',
      'Guía de tiempos exactos por alimento y gramaje',
      'Recetas de pechuga · huevos · vegetales · hamburguesas',
      'Cómo resolver la semana combinando ambos electrodomésticos',
    ],
  },
  {
    number: 5,
    emoji: '📓',
    tag: 'Viandas',
    title: 'Viandas Anti-Fracaso · Meal Prep',
    accent: '#b6e2f7',
    tagline: 'Para los que trabajan y quieren comer bien lejos de casa.',
    bullets: [
      '5 días de proteína lista en 2 horas el domingo',
      'Sistema de tuppers etiquetados: LUNES a VIERNES',
      'Opciones sin cadena de frío para llevar al trabajo',
      'Planificador semanal + checklist nocturno imprimible',
    ],
  },
  {
    number: 6,
    emoji: '📒',
    tag: 'Salsas',
    title: 'Salsas y Aderezos Anabólicos',
    accent: '#f4a7a7',
    tagline: 'Lo que hace que comer proteína todos los días no aburra nunca.',
    bullets: [
      '20 salsas y aderezos proteicos listos en 5 minutos',
      'Tahini · Chimichurri proteico · Yogur especiado · Mojo de ajo',
      'Sistema de frascos para tener aderezos listos toda la semana',
      'Tabla de combinaciones: qué salsa va con qué proteína',
    ],
  },
]

export const tomoIncludes: string[] = [
  'Lista de compras semanal incluida',
  'Checklist imprimible de cada sistema',
  'Tabla de tiempos exactos por receta',
  'Ingredientes de súper, feria o verdulería de barrio',
  'Diseñado 100% para el argentino — sin ingredientes raros',
  '100% listo — abrís el PDF y arrancás',
]
